import { useEffect, useState } from 'react';
import {
    Box, Grid, CardContent, Fab, Typography,
    CardHeader, Divider, Paper, TextField,
    Table, TableHead, TableRow, TableCell,
    TableBody, Button
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import axios from 'axios';
import Swal from "sweetalert2";

interface Job {
    id: any;
    wo_order_id: any;
    tgl: any;
    keterangan: any;
}

interface Barang {
    id: any;
    nama_barang: any;
    qty: any;
    qty_pemenuhan: any;
    satuan: any;
}

export default function Index() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [selectedJob, setSelectedJob] = useState<Job | null>(null);
    const [listJob, setListJob] = useState<Job[]>([]);
    const [listBarang, setListBarang] = useState<Barang[]>([]);
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    useEffect(() => {

        // Simulasi fetch data joblist
        const fetchJobs = async () => {
            try {
                const url = `${apiUrl.apiUrl}/production/work-order/list-request-job`;
                const response = await axios.get(url, {
                    params: {},
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.data.success) {
                    setListJob(response.data.data);
                } else {
                    throw new Error(response.data.message);
                }
            } catch (error: any) {
                console.error('Error fetching doctag:', error);
                throw error;
            }
        };
        fetchJobs();
    }, []);

    const fetchBarangForJob = async (jobId: any) => {
        try {
            const url = `${apiUrl.apiUrl}/production/work-order/detail-request-job/${jobId}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {

                setListBarang(response.data.data);
            } else {
                throw new Error(response.data.message);
            }
        } catch (error: any) {
            console.error('Error fetching barang:', error);
            throw error;
        }
    };

    const filteredJobs = listJob.filter(
        (j) =>
            String(j.id).includes(search) ||
            String(j.wo_order_id).includes(search) ||
            String(j.keterangan).includes(search)
    );

    const handleQtyChange = (index: number, value: number) => {
        const updated = [...listBarang];
        updated[index].qty_pemenuhan = value;
        setListBarang(updated);
    };

    const handleSave = async () => {
        if (!selectedJob) {
            Swal.fire({
                icon: 'warning',
                title: 'Pilih joblist terlebih dahulu',
            });
            return;
        }

        try {
            const url = `${apiUrl.apiUrl}/production/work-order/save-request-job`;
            const response = await axios.post(url, {
                job_id: selectedJob.id,
                items: listBarang.map(item => ({
                    id: item.id,
                    qty_pemenuhan: item.qty_pemenuhan || 0
                }))
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Data berhasil disimpan',
                    timer: 1500,
                    showConfirmButton: false
                });
                setSelectedJob(null);
                setListBarang([]);
            } else {
                throw new Error(response.data.message);
            }
        } catch (error: any) {
            console.error('Error saving joblist:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Terjadi kesalahan saat menyimpan data',
            });
        }
    };

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                bgcolor: "#f5f5f5",
                overflow: "hidden",
                p: 2,
                boxSizing: "border-box",
            }}
        >
            <Grid container spacing={2} sx={{ flex: 1, overflow: "hidden" }}>
                {/* HEADER */}
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'space-between' }}>
                        <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                            <Icon icon='mdi:arrow-left' />
                            Kembali
                        </Fab>
                    </Box>
                </Grid>

                {/* KIRI */}
                <Grid
                    item
                    xs={4}
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div
                        className="content-block dx-card"
                        style={{
                            borderRadius: 10,
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            background: "#fff",
                            marginBottom: 2,
                        }}
                    >
                        <CardHeader title="Daftar Joblist" />
                        <CardContent
                            sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                            }}
                        >
                            {/* Search bar */}
                            <TextField
                                size="small"
                                placeholder="Cari Joblist..."
                                fullWidth
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: "auto",
                                    pr: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1
                                }}
                            >
                                {filteredJobs.map((job) => (
                                    <Paper
                                        key={job.id}
                                        elevation={1}
                                        onClick={() => {
                                            setSelectedJob(job);
                                            fetchBarangForJob(job.id);
                                        }}
                                        sx={{
                                            p: 1.5,
                                            borderRadius: 2,
                                            cursor: "pointer",
                                            transition: "0.2s",
                                            border:
                                                selectedJob?.id === job.id
                                                    ? "2px solid #1976d2"
                                                    : "1px solid #ddd",
                                            backgroundColor:
                                                selectedJob?.id === job.id ? "#E3F2FD" : "#fff",
                                            "&:hover": { backgroundColor: "#F5F5F5" },
                                            color: '#212121'
                                        }}
                                    >
                                        <Typography variant="subtitle2" fontWeight="bold">
                                            REQUEST ID : {job.id}
                                        </Typography>
                                        <Divider sx={{ my: 1 }} />
                                        <Typography variant="body2" color="text.secondary">
                                            TGL : {job.tgl}
                                        </Typography>
                                        <Typography variant="body1">Work Order : {job.wo_order_id}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Keterangan : {job.keterangan}
                                        </Typography>
                                    </Paper>
                                ))}
                            </Box>
                        </CardContent>
                    </div>
                </Grid>

                {/* KANAN */}
                <Grid item xs={8} sx={{ height: "100%" }}>
                    <div
                        className="content-block dx-card"
                        style={{
                            borderRadius: 10,
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <CardHeader title="Detail Joblist" />
                        <CardContent
                            sx={{ flex: 1, display: "flex", flexDirection: "column", p: 2 }}
                        >
                            {selectedJob ? (
                                <>
                                    {/* HEADER DETAIL */}
                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(2, 1fr)",
                                            gap: 1,
                                            mb: 2,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 2,
                                            p: 2,
                                            background: "#FAFAFA",
                                        }}
                                    >
                                        <Typography>
                                            <b>ID:</b> {selectedJob.id}
                                        </Typography>
                                        <Typography>
                                            <b>Work Order:</b> {selectedJob.wo_order_id}
                                        </Typography>
                                        <Typography>
                                            <b>Tanggal:</b> {selectedJob.tgl}
                                        </Typography>
                                        <Typography>
                                            <b>Keterangan:</b> {selectedJob.keterangan}
                                        </Typography>
                                    </Box>

                                    {/* TABLE BARANG */}
                                    <Box
                                        sx={{
                                            overflowY: "auto",
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 2,
                                            maxHeight: 400, // 👈 kalau datanya banyak baru scroll
                                        }}
                                    >
                                        <Table size="small" stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Nama Barang</TableCell>
                                                    <TableCell align="center">Qty Kebutuhan</TableCell>
                                                    <TableCell align="center">Pemenuhan</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {listBarang.map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{item.nama_barang}</TableCell>
                                                        <TableCell align="center">{item.qty} {item.satuan}</TableCell>
                                                        <TableCell align="center">
                                                            <TextField
                                                                type="number"
                                                                size="small"
                                                                value={item.qty_pemenuhan || ''}
                                                                onChange={(e) =>
                                                                    handleQtyChange(index, Number(e.target.value))
                                                                }
                                                                sx={{ width: 80 }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>

                                    {/* BUTTON SIMPAN */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            mt: 4,
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSave}
                                            sx={{ textTransform: "none", px: 4 }}
                                        >
                                            Simpan
                                        </Button>
                                    </Box>
                                </>
                            ) : (
                                <Typography color="text.secondary">
                                    Pilih salah satu joblist di sebelah kiri.
                                </Typography>
                            )}
                        </CardContent>
                    </div>
                </Grid>

            </Grid>
        </Box>
    );
}
